import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';

import { authService } from 'auth/services';

import { MsalProvider } from '@azure/msal-react';

import { RouterComponent } from './router';
import store from './store';

export function App(): React.ReactElement | null {
  const [isInitialized, setIsInitialized] = useState<boolean>(false);

  useEffect(() => {
    const init = async (): Promise<void> => {
      await authService.initAuthService();
      setIsInitialized(true);
    };
    init();
  }, []);

  if (!isInitialized) {
    return null;
  }

  return (
    <MsalProvider instance={authService.getMsalInstance()}>
      <Provider store={store}>
        <RouterComponent />
      </Provider>
    </MsalProvider>
  );
}
